import PropTypes from 'prop-types';

/**
 * Generates an object with a random generated id and a given value.
 * @param {string} defaultValue
 * @return {Object}
 */
export const getDefaultStyle = (defaultValue) => ({
    value: defaultValue,
});

export const styleShapePropTypes = PropTypes.shape({
    value: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});
